import {REMOVE_ERROR} from 'constants/actionTypes';
export const removeError = (id) => ({type: REMOVE_ERROR, id});


// WEBPACK FOOTER //
// ./src/actions/errorActions.js